const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    if (window.Razorpay) {
      resolve(true);
      return;
    }
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

export const initiatePayment = async ({
  amount,
  name,
  email,
  phone,
  description,
  onSuccess,
  onFailure,
}) => {
  const keyId = process.env.REACT_APP_RAZORPAY_KEY_ID;

  if (!keyId) {
    onFailure?.(
      new Error(
        "Payment gateway not configured. Add REACT_APP_RAZORPAY_KEY_ID to your .env file."
      )
    );
    return;
  }

  const loaded = await loadRazorpayScript();
  if (!loaded) {
    onFailure?.(new Error("Failed to load payment gateway. Please try again."));
    return;
  }

  const options = {
    key: keyId,
    amount: amount * 100,
    currency: "INR",
    name: "Ever Sky Overseas",
    description: description || "Service Purchase",
    prefill: { name, email, contact: phone },
    theme: { color: "#2d377a" },
    handler: (response) => {
      onSuccess?.(response);
    },
    modal: {
      ondismiss: () => {
        onFailure?.(new Error("Payment cancelled"));
      },
    },
  };

  const razorpay = new window.Razorpay(options);
  razorpay.open();
};

export const submitLeadForm = (formData, formType = "contact") => {
  const leads = JSON.parse(localStorage.getItem("eversky_leads") || "[]");
  leads.push({
    ...formData,
    formType,
    submittedAt: new Date().toISOString(),
  });
  localStorage.setItem("eversky_leads", JSON.stringify(leads));
  return true;
};
